import React from 'react';
import { BRAND_LOGO_SQUARE } from '../brandAssets';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="w-full h-screen bg-brand-cream flex flex-col items-center justify-center relative overflow-hidden">
      
      {/* Pulsing Brand Logo */}
      <div className="z-20 flex flex-col items-center animate-pulse">
        <img 
            src={BRAND_LOGO_SQUARE} 
            alt="Loading..." 
            className="w-24 h-24 rounded-full shadow-xl mb-4"
        />
        <p className="font-display font-extrabold text-brand-dark text-lg">Loading your map...</p>
      </div>

      {/* Grid Background (Mimics Map) */}
      <div className="absolute inset-0 z-10 pointer-events-none bg-grid-pattern animate-grid-pulse opacity-30"></div>
    </div>
  );
};
